const notSupported = 'terra-react is not supported on web'

const Connections = {
  APPLE_HEALTH: 'APPLE_HEALTH',
  HEALTH_CONNECT: 'HEALTH_CONNECT',
  GOOGLE_FIT: 'GOOGLE_FIT',
}

const CustomPermissions = {
  WEIGHT: 'WEIGHT',
  STEPS: 'STEPS',
  SLEEP_ANALYSIS: 'SLEEP_ANALYSIS',
  WORKOUT_TYPES: 'WORKOUT_TYPES',
  BLOOD_GLUCOSE: 'BLOOD_GLUCOSE',
}

const successMessage = { success: true, error: null }
const unsupportedMessage = { success: false, error: notSupported }

const initTerra = async () => successMessage
const initConnection = async () => unsupportedMessage
const checkAuth = async () => ({ success: false })
const getUserId = async () => ({ success: false, userId: null })

const getBody = async () => ({ success: true, data: { data: [] }, error: null })
const getActivity = async () => ({ success: true, data: { data: [] }, error: null })
const getDaily = async () => ({ success: true, data: { data: [] }, error: null })
const getSleep = async () => ({ success: true, data: { data: [] }, error: null })

const getMenstruation = async () => ({ success: true, data: { data: [] }, error: null })
const getNutrition = async () => ({ success: true, data: { data: [] }, error: null })
const getAthlete = async () => ({ success: true, data: {}, error: null })
const postActivity = async () => unsupportedMessage
const getPlannedWorkouts = async () => ({ success: true, data: [] })
const deletePlannedWorkout = async () => unsupportedMessage
const completePlannedWorkout = async () => unsupportedMessage
const postPlannedWorkout = async () => unsupportedMessage

const readGlucoseData = async () => ({})
const activateSensor = async () => ({})
const openHealthConnect = () => {}
const isHealthConnectAvailable = async () => false
const grantedPermissions = async () => []
const setIgnoredSources = () => {}

module.exports = {
  Connections,
  CustomPermissions,
  initTerra,
  initConnection,
  checkAuth,
  getUserId,
  getBody,
  getActivity,
  getDaily,
  getSleep,
  getMenstruation,
  getNutrition,
  getAthlete,
  postActivity,
  getPlannedWorkouts,
  deletePlannedWorkout,
  completePlannedWorkout,
  postPlannedWorkout,
  readGlucoseData,
  activateSensor,
  openHealthConnect,
  isHealthConnectAvailable,
  grantedPermissions,
  setIgnoredSources,
}
